<script>
  import { onDestroy, onMount, tick } from 'svelte';
  import session from '../lib/session';
  import settings from '../config';
  import { show_message } from '../lib/flash';
  import { createVideo } from '../lib/youtube-vimeo-validator.js';
  import * as linkify from 'linkifyjs';
  import { TS } from '../config/translation-keys.js';
  import { set_language, t9n } from '../lib/translate.js';
  import Share from '../orders/orderDetails/components/Share.svelte';
  import APIClient from '../state-charts/api-client';
  import ShareCV from './ShareCV.svelte';
  import SvelteSwitch from '../lib/components/SvelteSwitch.svelte';
  import {
    enable_cv_page_cache_control,
    disable_cv_page_cache_control,
  } from './cv-cache-control.js';

  export let route_name;
  export let worker_uuid;

  let print_label;
  let about_title;
  let education_title;
  let educations_completed_text;
  let languages_title;
  let experiences_title;
  let current_experience_text;
  let work_fields_title;
  let worked_amount_text;
  let wp_tasks_title;
  let no_tasks_message;
  let success_message;
  let error_message;
  let save_colors;
  let cv_switch_tooltip;
  let cv_change_themes;
  let cv_customise_background_color;
  let has_init = false;
  let is_visible = false;

  const translate_texts = () => {
    print_label = t9n(TS.CV_PRINT_LABEL);
    about_title = t9n(TS.CV_ABOUT_ME);
    education_title = t9n(TS.CV_EDUCATION_AND_CERTIFICATES);
    educations_completed_text = t9n(TS.ORDER_COMPLETED_TXT);
    languages_title = t9n(TS.CV_LANGUAGES);
    experiences_title = t9n(TS.CV_MY_EXPERIENCES);
    current_experience_text = t9n(TS.CV_CURRENT);
    work_fields_title = t9n(TS.CV_WORKED_FIELDS);
    worked_amount_text = t9n(TS.CV_WORKED_TIMES);
    wp_tasks_title = t9n(TS.CV_LABEL_COMPLETED_GIGS);
    no_tasks_message = t9n(TS.CV_NO_COMPLETED_TASKS_YET);
    success_message = t9n(TS.SAVE_CV_COLORS_SUCCESS);
    error_message = t9n(TS.SAVE_CV_COLORS_SUCCESS);
    save_colors = t9n(TS.SAVE_CV_COLORS);
    cv_switch_tooltip = t9n(TS.CV_SWITCH_TOOLTIP);
    cv_change_themes = t9n(TS.CV_CHANGE_THEMES);
    cv_customise_background_color = t9n(TS.CV_CUSTOMISE_BACKGROUND_COLOR);
  }

  let cv_data;
  let cv_gigs;
  let profile_image;
  let cv;
  let worker;
  let educations;
  let experiences;
  let languages;
  let categories;
  let feedbacks;
  let video;
  let share_dialog;
  let experience_videos = [];
  let hide_feedbacks_on_cv = false;
  let cv_input_color_on_init;
  let save_cv_disabled = true;
  let number_of_pages;

  const print_cv = () => {
    let pic_style;
    document.querySelector('.print-cv').disabled = true
    document.querySelector(".loading").style.display = "block";
    if (document.getElementById('share-dialog')) document.getElementById('share-dialog').remove();
    if (document.getElementById("pic_style")) pic_style = document.getElementById("pic_style").textContent;
    printJS({
      printable: 'the_cv',
      type: 'html',
      targetStyles: '[*]',
      scanStyles: false,
      style: pic_style,
      css: [
        '/css/cv/bootstrap.min.css',
        '/css/cv/font-awesome.min.css',
        '/css/cv/workerCV.css',
        '/css/cv/workerCV_print.css',
      ],
      onPrintDialogClose: function() {
        document.querySelector('.print-cv').disabled = false
        document.querySelector(".loading").style.display = "none";
      },
    });
    setTimeout(function() {
      document.querySelector('.print-cv').disabled = false
      document.querySelector('.loading').style.display = "none";
    }, 1000);
  };

  const hide_feedbacks = async () => {
    let data = { hide_feedbacks_on_cv: true };
    await APIClient.update_profile(data);
    hide_feedbacks_on_cv = true;
  };

  const show_feedbacks = async () => {
    let data = { hide_feedbacks_on_cv: false };
    await APIClient.update_profile(data);
    hide_feedbacks_on_cv = false;
  };

  const toggle_order = async (order, value) => {
    let data = {
      'hide_order_on_cv': !value,
      'order_uuid': order,
    };
    await APIClient.hide_order_on_cv(data);
  };

  const bool_inverter = e => {
    e.hide_order_on_cv = !e.hide_order_on_cv;
    return e;
  };

  const insert_profile_image = () => {
    profile_image = settings.api_host + worker.image_url;
  };

  const open_share_dialog = () => {
    let target = document.querySelector('.share-dialog');
    target.innerHTML = '';
    share_dialog = new ShareCV({
      target: target,
      props: { worker_uuid: worker_uuid },
    });
    share_dialog.open();
  };

  const format_experience_date = experience => {
    let date = experience.start_month + '/' + experience.start_year + ' - ';
    if (experience.is_current) {
      date = date + current_experience_text;
    } else {
      date = date + experience.end_month + '/' + experience.end_year;
    }
    return date;
  };

  const get_rating_value = (rating) => {
    switch(rating){
      case 'sad':
        return 1;
      case 'neutral':
        return 2.5;
      case 'happy':
        return 4;
      case 'extremely_happy':
        return 5;
      default:
        return 0;
    }
  }

  const format_rating_style = () => {
    let rating_sum = 0;
    let rating_length = 0;
    feedbacks.forEach((el) => {
        rating_length++;
        rating_sum += get_rating_value(el.rating);
      }
    )

    let ratingPercentage = ((rating_sum / rating_length) / 5) * 100;
    ratingPercentage = Math.max(0, Math.min(100, ratingPercentage));
    return `width: ${ratingPercentage}%;`;
  };

  const init_about_video = async () => {
    if (!!video) {
      let wait = setInterval(() => {
        let video_el = document.getElementById('video_description');
        if (video_el) {
          video_el.append(video);
          clearInterval(wait);
        }
      }, 100);
    }
  };

  const init_experiences_videos = async () => {
    if (!!experience_videos) {
      let wait = setInterval(() => {
        for (let i = 0; i < experience_videos.length; i++) {
          if (experience_videos[i] !== 'NOVIDEO') {
            let video_el = document.getElementById('experience_video_' + i);
            if (video_el) {
              video_el.append(experience_videos[i]);
            }
          }
        }
        clearInterval(wait);
      }, 100);
    }
  };

  const init_experience_descriptions = () => {
    if (document.querySelector('.experience_description')) {
      let descriptions = document.querySelectorAll('.experience_description')
      //if (descriptions.length > 0) descriptions.linkify();
    }
  };

  const init_print = () => {
    document.querySelector(".print-cv").style.display = "block";
    document.querySelector(".loading").style.display = "none";
    document.querySelector(".print-cv").onclick = function() {print_cv()};
  };

  const handleThemeUpdate = cssVars => {
    const root = document.querySelector(':root');
    const keys = Object.keys(cssVars);
    keys.forEach(key => {
      root.style.setProperty(key, cssVars[key]);
    });
    save_cv_disabled = false;
  };

  const init_color_picker = () => {
    const themes_holder = document.querySelector('#themes_holder');
    const dynamicInputs = document.querySelectorAll('input.input-color-picker');

    dynamicInputs.forEach(item => {
      item.addEventListener('input', e => {
        const cssPropName = `--primary-${e.target.getAttribute('data-id')}`;
        let rgb = hexToRGBarr(e.target.value);
        let right_bg_color = setForegroundColor(rgb);
        handleThemeUpdate({
          [cssPropName]: e.target.value,
          '--primary-color': right_bg_color,
        });
      });
    });

    if (themes_holder) {
      const themeSwitchers = themes_holder.querySelectorAll('span');
      themeSwitchers.forEach(item => {
        item.addEventListener('click', e => {
          const bgColor = e.target.getAttribute('data-bg-color');
          let rgb = hexToRGBarr(bgColor);
          let right_bg_color = setForegroundColor(rgb);
          handleThemeUpdate({
            '--primary-bg-color': bgColor,
            '--primary-color': right_bg_color,
          });
        });
      });
    } else {
      console.warn('No themes holder in CV!');
    }
  };

  function setForegroundColor(rgb) {
    let sum = Math.round(
      (parseInt(rgb[0]) * 299 +
        parseInt(rgb[1]) * 587 +
        parseInt(rgb[2]) * 114) /
      1000,
    );
    return sum > 128 ? 'grey' : 'white';
  }

  function hexToRGBarr(h) {
    let r = 0,
      g = 0,
      b = 0;

    // 3 digits
    if (h.length == 4) {
      r = '0x' + h[1] + h[1];
      g = '0x' + h[2] + h[2];
      b = '0x' + h[3] + h[3];

      // 6 digits
    } else if (h.length == 7) {
      r = '0x' + h[1] + h[2];
      g = '0x' + h[3] + h[4];
      b = '0x' + h[5] + h[6];
    }

    return [r, g, b];
  }

  const save_cv_colors = async (with_success_message = true) => {
    let data = {
      cv_colors: {
        custom_background_color: document
          .querySelector(':root')
          .style.getPropertyValue('--primary-bg-color'),
        custom_font_color: document
          .querySelector(':root')
          .style.getPropertyValue('--primary-color'),
      },
    };
    let result = await APIClient.update_profile(data);
    if (with_success_message) {
      if (result) {
        show_message(success_message, 'success');
      } else {
        show_message(error_message, 'error');
      }
    }
  };

  const get_cv_colors = async () => {
    let results = $session.user;
    if (results) {
      if (results.cv_colors.custom_background_color == null)
      {
        set_merchant_colors();
      } else {
        document
          .querySelector(':root')
          .style.setProperty(
          '--primary-bg-color',
          results.cv_colors.custom_background_color,
        );
        document
          .querySelector(':root')
          .style.setProperty(
          '--primary-color',
          results.cv_colors.custom_font_color,
        );
      }
      cv_input_color_on_init = results.cv_colors.custom_background_color;
      if (results.hide_feedbacks_on_cv === true) {
        hide_feedbacks_on_cv = true;
      }
    }
  };

  const set_merchant_colors = () => {
    if (if_mobile) {
      document.querySelector(':root').style.setProperty(
        '--primary-bg-color', cv_data.cv_colors.merchant_cv_color);
    } else {
      document.querySelector(':root').style.setProperty(
        '--primary-bg-color', $session.branding.vars.merchant_cv_color);
    }
    save_cv_colors(false);
  }

  const sort_experiences = () => {
    experiences.sort((a, b) => {
      let keyA = new Date(a.start_year, a.start_month);
      let keyB = new Date(b.start_year, b.start_month);
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });
    experiences.sort(function(a,b) {
      if (!a['is_current'] && b['is_current'])
        return 1;
      if (a['is_current'] && !b['is_current'])
        return -1;
      return a['is_current'] - b['is_current']
    });
  };

  const sort_educations = () => {
    educations.sort((a, b) => {
      let keyA = new Date(a.completed_year, a.completed_month);
      let keyB = new Date(b.completed_year, b.completed_month);
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      return 0;
    });
    educations.sort(function(a,b) {
      if (!a['completed_is_current'] && b['completed_is_current'])
        return 1;
      if (a['completed_is_current'] && !b['completed_is_current'])
        return -1;
      return a['completed_is_current'] - b['completed_is_current']
    });
  };

  let if_mobile = false;

  const init_data = async () => {
    worker = cv_data.worker;

    educations = worker.educations;
    experiences = worker.experiences;
    sort_educations();
    sort_experiences();
    languages = worker.languages;
    categories = cv_data.categories;
    feedbacks = cv_gigs.feedbacks.map(bool_inverter)  // this inversion is needed for the new SvelteSwitch
    number_of_pages = cv_gigs.results_info.number_of_pages;

    if (worker && !!worker.video_link) {
      video = createVideo(worker.video_link);
    }

    if (experiences) {
      for (let experience of experiences) {
        if (!!experience.video_link) {
          experience_videos.push(
            createVideo(experience.video_link, '80%', '80%'),
          );
        } else {
          experience_videos.push('NOVIDEO');
        }
      }
    }

    await get_cv_colors();
    await init_about_video();
    await init_experiences_videos();

    insert_profile_image();
    init_experience_descriptions();
    init_print();
    init_color_picker();
  };

  const init_cv = async () => {
    document
      .querySelector('.mdc-top-app-bar--fixed-adjust')
      .scrollIntoView({ behavior: 'smooth' });

    document.querySelector(".loading").classList.remove('hidden')
    translate_texts();
    const urlParams = new URLSearchParams(window.location.search);
    if_mobile = !!urlParams.get('app_language');

    let language;

    if (if_mobile) {
      language = urlParams.get('app_language');
      document
        .querySelector('#debug_print').innerHTML = language;
      set_language(language);
      translate_texts();
    } else {
      language = $session.language;
    }
    let per_page = 100;
    let current_page = 1;

    let api_data = {
      page: current_page,
      number_of_items_per_page: per_page,
      for_all_merchants: true,
    };

    cv_data = await APIClient.get_worker_cv(worker_uuid, language);
    cv_gigs = await APIClient.get_feedbacks('worker', api_data);
    await init_data();
    document.querySelector(".loading").classList.add('hidden')
    has_init = true;
  };

  onMount(async () => {
    enable_cv_page_cache_control();
    await init_cv();
  });

  onDestroy(disable_cv_page_cache_control);

  // $: if($session.route){
  //   if($session.route.includes('/cv') && !has_init){
  //     (async () => {
  //       await init_cv();
  //     })();
  //   }
  // }


</script>

<svelte:head>
  <link rel="stylesheet" href="/css/cv/print.min.css" />
  <link rel="stylesheet" href="/css/cv/workerCV.css" />
  <link rel="stylesheet" href="/css/cv/wp.css" />
  <link rel="stylesheet" href="/css/cv/font-awesome.min.css" />

  <link
    href="https://fonts.googleapis.com/css?family=Open+Sans:400,300,300italic,400italic,600,600italic,700,700italic,800,800italic);"
    rel="stylesheet"
    type="text/css" />

  <script src="/js/cv/bootstrap.min.js" defer>

  </script>
  <script src="/js/cv/print.min.js" type="text/javascript" defer>

  </script>
</svelte:head>

<!-- Theme selector -->
<div class="cv-container">

  <div class="theme-switcher no_print no-mobile">
    <div class="flex items-center">
      <div class="flex flex-wrap justify-between">

        <h3 class="font-bold center-align">{cv_change_themes}</h3>
        <div id="themes_holder" class="flex">
          <span
            class="themes"
            data-bg-color="#b84130"
            data-color="#ffffff"
            style="background-color: #b84130">
            &nbsp;
          </span>
          <span
            class="themes"
            data-bg-color="#363d98"
            data-color="#ffffff"
            style="background-color: #363d98">
            &nbsp;
          </span>
          <span
            class="themes"
            data-bg-color="#479a8a"
            data-color="#ffffff"
            style="background-color: #479a8a">
            &nbsp;
          </span>
        </div>
      </div>
      <h3 class="font-bold center-align">{cv_customise_background_color}</h3>
      <div class="flex items-center">
        <div class="flex items-center">
          <input
            class="center-align input-color-picker"
            type="color"
            data-id="bg-color"
            name="Background"
            value={cv_input_color_on_init} />
        </div>
      </div>

      <div style="margin: auto; text-align: right;">
        <button
          on:click|stopPropagation|preventDefault={save_cv_colors}
          disabled={!!save_cv_disabled}
          data-cy="save-cv"
          style="margin-left: 30px;"
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {save_colors}
        </button>
      </div>
    </div>
  </div>



  <!-- CV main -->
  <div class="cv-content container" id="the_cv">
    <div class="row">
      <div class="share-dialog" />
      <div class="cv-left left col-sm-5">
        <button class="print-cv no_print">{print_label}</button>
        <!--                    <div style="float: left;">-->
        <div class="profile-image-pos">
          <svg width="200" height="215" viewBox="0 0 200 215">
            <defs>
              <clipPath id="shape">
                <path
                  transform="rotate(90, 100, 109)"
                  d="m-3.5,113.26279q-2.5,-4.33012
                  0,-8.66025l47.5,-82.27241q2.5,-4.33013 7.5,-4.33013l95,0q5,0
                  7.5,4.33013l47.5,82.27241q2.5,4.33013
                  0,8.66025l-47.5,82.27242q-2.5,4.33012 -7.5,4.33012l-95,0q-5,0
                  -7.5,-4.33012l-47.5,-82.27242z" />
              </clipPath>
            </defs>
            <image
              preserveAspectRatio="xMidYMid slice"
              width="100%"
              height="100%"
              clip-path="url(#shape)"
              href={profile_image} />
          </svg>
        </div>

        <h1 id='debug_print'></h1>

        <div class="worker_contacts">
          <span class="loading no_print hidden">
            <i class="fa fa-spin fa-spinner" />
          </span>
          <div
            class="inner"
            title={worker ? `${worker.first_name} ${worker.last_name}` : "user's name"}>
            <span style="font-weight: 600; font-size: 20px;" class="last_name">
              {worker ? worker.first_name : ''} {worker ? worker.last_name : ''}
            </span>
          </div>
          <p style="margin-top: 3px" class="worker_email">
            {worker ? worker.email : ''}
          </p>
          <p style="margin-top: -14px" class="worker_phone">
            {worker ? `${worker.phone.code} ${worker.phone.number}` : ''}
          </p>
        </div>

        {#if worker && (worker.short_description_worker || worker.video_link)}
          <div class="left-section about">
            <h4 class="section-title">{about_title}</h4>
            {#if worker.short_description_worker}
              <p class="section-content about_me" style='white-space: pre-line;'>
                {worker.short_description_worker}
              </p>
            {/if}
            {#if !!video}
              <div class="videoWrapper no_print" id="video_description" />
              <!--{:else}-->
              <!--    <div class="videoWrapper no_print"/>-->
            {/if}
          </div>
        {/if}

        {#if !!educations && educations.length > 0}
          <div class="left-section educations">
            <h4 class="section-title">{education_title}</h4>
            <div style="margin-top:15px;">
              {#each educations as education}
                <div style="margin-top:20px" class="education">
                  <div style="float:left;text-align: center;width:60px;">
                    <i
                      class="education_icon fa"
                      class:fa-graduation-cap={education.education_type === 'worker_education_type_education'}
                      class:fa-certificate={education.education_type !== 'worker_education_type_education'}
                      style="font-size:26px;" />
                  </div>
                  <div style="padding-left:60px;">
                    <div>
                      <b class="education_title">{education.title}</b>
                    </div>
                    <div
                      style="font-size:14px;font-weight: 300"
                      class="education_where">
                      {education.where}
                    </div>
                    {#if !education.completed_is_current}
                      <div
                        style="font-size:14px;font-weight: 300"
                        class="education_conclusion">
                        {`${educations_completed_text}: ${education.completed_month}/${education.completed_year}`}
                      </div>
                    {/if}
                  </div>
                </div>
              {/each}
            </div>
          </div>
        {/if}

        {#if !!languages}
          <div class="left-section languages">
            <h4 class="section-title">{languages_title}</h4>
            <div class="text-centered">
              {#each languages as language}
                <div class="language">
                  <span class="language_name" title={language.level_name}>
                    {t9n(language.language_name)}
                  </span>
                  <img
                    class="language-level"
                    alt={t9n(language.language_name)}
                    src={`/assets/level/lvl${language.level}.png`} />
                </div>
              {/each}
            </div>
          </div>
        {/if}
      </div>

      <div class="cv-right col-sm-7 right">
        {#if !!experiences}
          <div class="right-section experiences">
            <h4 class="section-title" style="position: relative">
              {experiences_title}
              <button
                on:click={() => open_share_dialog()}
                class="btn-share mdc-button mdc-button--unelevated">
                <span class="mdc-button__ripple" />
                {t9n(TS.CV_SHARE)}
              </button>
            </h4>

            {#each experiences as experience, i}
              <div class="experience">
                <i
                  class="experience_icon fa"
                  class:fa-suitcase={experience.experience_type === 'worker_experience_type_job'}
                  class:fa-folder={experience.experience_type !== 'worker_experience_type_job'} />
                <div>
                  <span class="experience_title">{experience.position}</span>
                  -
                  <span class="experience_where">{experience.where}</span>
                  <div class="experience_date">
                    {format_experience_date(experience)}
                  </div>
                  {#if experience.description}
                    <div class="experience_description">
                      {@html experience.description.replace(/\n/g, '<br />')}
                    </div>
                  {/if}
                  {#if !!experience.video_link}
                    <div
                      class="exp-video-wrapper no_print"
                      id="experience_video_{i}" />
                    <!--                                            <div class="experience_video no_print"-->
                    <!--                                                <span class="link">{experience.video_link}</span>-->
                  {/if}
                </div>
              </div>
            {/each}
          </div>
        {/if}

        {#if !!categories}
          <div class="right-section categories">
            <h4 class="section-title">{work_fields_title}</h4>
            {#each categories as category}
              <div
                class="category"
                title={worked_amount_text.format(category.amount)}>
                <span class="category_name">{category.name}</span>
                <span class="category_count">{category.amount}</span>
              </div>
            {/each}
          </div>
        {/if}

        {#if !!feedbacks}
          <div class="right-section feedbacks">
            {#if feedbacks.length > 0}
              <h4 class="section-title">
                {wp_tasks_title}
                <div class="hexagon_rating">
                  <div class="background">
                    <span class="hex empty" />
                    <span class="hex empty" />
                    <span class="hex empty" />
                    <span class="hex empty" />
                    <span class="hex empty" />
                  </div>
                  <div class="foreground" style={format_rating_style(worker)}>
                    <span class="hex filled" />
                    <span class="hex filled" />
                    <span class="hex filled" />
                    <span class="hex filled" />
                    <span class="hex filled" />
                  </div>
                </div>

                <div
                  class="no_print"
                  style="text-align: right; margin-top: -36px;">
                  {#if hide_feedbacks_on_cv}
                    <button
                      on:click|stopPropagation|preventDefault={show_feedbacks}
                      class="btn-share mdc-button mdc-button--unelevated"
                      style="position: relative">
                      <span class="mdc-button__ripple" />
                      {t9n(TS.CV_SHOW_ALL_FEEDBACK)}
                    </button>
                  {:else}
                    <button
                      on:click|stopPropagation|preventDefault={hide_feedbacks}
                      class="btn-share mdc-button mdc-button--unelevated"
                      style="position: relative">
                      <span class="mdc-button__ripple" />
                      {t9n(TS.CV_HIDE_ALL_FEEDBACK)}
                    </button>
                  {/if}
                </div>
              </h4>

              {#if feedbacks}
                <div class="tooltip-default no_print">
                  <div
                    id="tooltip_def"
                    class="tooltip-text tooltip-top"
                    style="background-color:var(--mdc-theme-secondary); color:
                    rgb(255, 255, 255);">
                    {cv_switch_tooltip}
                  </div>
                </div>
              {/if}

              <!-- todo: add pagination -->
              {#each feedbacks as fb, i}
                <div
                  class="review-item"
                  class:task-opacity={!fb.hide_order_on_cv}
                  class:no_print={!fb.hide_order_on_cv}>
                  <div class="review-reviewer">
                    <div
                      class="inline-block no_print"
                      style="display: inline-block; margin-right: 0px; margin-top: 4px;">
                      {#if fb.partner.organization_type !== "organization_type_private_person"}
                        {#if !fb.partner.organization_name}
                          <SvelteSwitch
                            label={`${fb.partner.first_name} ${fb.partner.last_name}:`}
                            bind:checked={fb.hide_order_on_cv}
                            on:change={async () => { await toggle_order(fb.uuid, fb.hide_order_on_cv) } }/>
                        {:else}
                          <SvelteSwitch
                            label={`${fb.partner.organization_name}`}
                            bind:checked={fb.hide_order_on_cv}
                            on:change={async () => { await toggle_order(fb.uuid, fb.hide_order_on_cv) } }/>
                        {/if}
                      {:else}
                        <SvelteSwitch
                          label={`${fb.partner.first_name} ${fb.partner.last_name}:`}
                          bind:checked={fb.hide_order_on_cv}
                          on:change={async () => { await toggle_order(fb.uuid, fb.hide_order_on_cv) } }/>
                      {/if}


                    </div>
                    <span class="order_title">{fb.description}</span>
                  </div>
                  {#if !!fb.message && hide_feedbacks_on_cv === false}
                    <div class="review-content" style="margin-left: 52px;">
                      {fb.message}
                    </div>
                  {/if}
                </div>
              {/each}
            {:else}
              <p
                class="no-tasks hidden"
                style="text-align: center;margin-top:10px; font-weight: 300;">
                {no_tasks_message}
              </p>
            {/if}
          </div>
        {/if}

      </div>
    </div>
  </div>
</div>

<style>
  .theme-switcher {
    display: flex;
    background: #fff5;
    margin: auto;
    margin-bottom: 1px;
    /*border-radius: 12px;*/
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    /*background: linear-gradient(180deg, rgba(235,235,235,.5) 1%, rgba(0,212,255,0) 100%);*/
    width: 90%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
    display: block;
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 32px;
    left: -343px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .task-opacity {
    opacity: 0.5;
  }

  .order_title {
    position: absolute;
    margin-top: 2px;
    margin-left: 5px;
  }

  .review-reviewer {
    padding-left: 7px;
    margin-bottom: -14px;
  }

  .themes {
    width: 40px;
    height: 40px;
    align-self: center;
    margin: 5px;
    cursor: pointer;
    border-radius: 999px;
  }

  .flex {
    display: flex;
  }

  .input-color-picker {
    height: 40px;
    padding: 0;
    cursor: pointer;
    width: 40px;
    margin-left: 10px;
    border-width: 0;
    /*background: var(--primary-bg-color);*/
  }

  .center-align {
    align-self: center;
  }

  .font-bold {
    margin-left: 10px;
  }

  h3 {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
    font-size: 15px;
  }

  h4 {
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
    margin-bottom: 10px;
  }

  .hexagon_rating {
      position: relative;
      display: inline-block;
  }

  @media print {
    body {
      -webkit-print-color-adjust: exact;
      color-adjust: exact !important;
      color: #0d47a1;
    }
  }
</style>
